import LayoutPage from "../../Components/LayoutPage";
import InformationCard from "./Components/InformationCard";
import ResetPassWordCard from "./Components/ResetPassWordCard";
import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../config/api";

export default function Profile() {
  const [accountData, setAccountData] = useState(null);
  const fetchAccountData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/auth/admin/info/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/info/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setAccountData(data);
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  useEffect(() => {
    fetchAccountData();
  }, []);
  return (
    <LayoutPage
      activeIndex={14}
      navItems={["حساب کاربری"]}
      childrenClassName="flex-1 min-h-0 flex flex-col items-center gap-5 overflow-auto"
    >
      <InformationCard accountData={accountData} />
      <ResetPassWordCard />
    </LayoutPage>
  );
}
